import React, { Component } from 'react';
import RadioButtonFiltros from './RadioButtonFiltros';
class TipoDeBusqueda extends Component {
    constructor(props) {
        super(props);
    }

    render() {

        const { data, actions, registrosActivos, arrayFiltrosDefinitivoLength } = this.props;

        let arrayFiltros = data.arrayFiltros;

        return (
            <div className="VistaInstanciaParametro-Filtros-Contenedor">
                <div>
                    <label className="VistaInstanciaParametro-Filtros-Label-Cabecera">Tipo de búsqueda</label>
                </div>

                {
                    arrayFiltros?.length > 0 &&
                    <div className='VistaInstanciaParametro-Filtros-Boton-Ver-Float'>
                        <button className="confirmadorAjusteCargoSeccionSuperiorBorrarFiltro left-separator-xs" data-toggle="tooltip" key={"limpiarFiltroBtn"} data-title={"Limpiar filtros"} data-placement="top" onClick={() => actions.getInstanciasLimpiarFiltros(registrosActivos, arrayFiltrosDefinitivoLength)}></button>
                        <button className="btn VistaInstanciaParametro-Filtros-Boton-Ver-Marign-Top btn-orange" onClick={() => actions.buscarDatosFiltrados(registrosActivos)}>Ver</button>
                    </div>
                }

                <div className='VistaInstanciaParametro-Filtros-Contenedor-Check'>
                    {
                        arrayFiltros?.length > 0 && arrayFiltros.map((filtro, index) => {
                            if (filtro.instancia.TipoCodigo == "TEXT" || filtro.instancia.TipoCodigo == "DATETIME") {
                                return <RadioButtonFiltros
                                    selectRadio={actions.selectRadio}
                                    index={index}
                                    PropiedadId={filtro.instancia.PropiedadId}
                                    rdSeleccionado={filtro.valorRadioButton} />
                            } else {
                                return <div className='VistaInstanciaParametro-Filtros-Sin-Check-Marign-Bottom'></div>;
                            }
                        })
                    }
                </div>
            </div>
        );
    }
}

export default TipoDeBusqueda;